import {addStyle, styleFromText, styleToText} from "./styles";
import {getJsDateFromExcel} from "../mathematics/methods";
import group from "./undo_group";
import * as arr from "../helpers/array";

export function init(view){
	view.attachEvent("onDataParse", (data) => load(view, data));
	view.attachEvent("onDataSerialize", (data, config) => serialize(view, data, config));
	view.attachEvent("onCommand", action => {
		if (["int", "price", "percent", "date", "string", "common"].indexOf(action.id) != -1) {
			addAreaFormat(view, action.group, action.id == "common" ? "" : action.id);
		}
	});
}

export function addAreaFormat(view, group, name, values){
	const sel = view._table.getSelectArea();
	if(sel){
		view.groupUndo(()=>{
			if(values)
				name = createFormat(view, name, values);

			if(group == "row")
				for(let r = sel.start.row; r <= sel.end.row; r++)
					applyAreaFormat(view, r, name, true);
			else
				for(let c = sel.start.column; c <= sel.end.column; c++)
					applyAreaFormat(view, c, name);

			view.refresh();
		});
	}
}

export function processAreaFormats(view, action, start, end){
	view.groupUndo(()=>{
		if(action.group == "column"){
			if(action.id == "add")
				for(let r = 1; r <= view.config.rowCount; r++){
					const prevCellFormat = getFormatName(view, r, start.column-1);
					if(prevCellFormat)
						for(let c = start.column; c <= end.column; c++)
							setFormat(view, r, c, prevCellFormat);
				}
		}
		else if(action.id == "add")
			for(let c = 1; c <= view.config.columnCount; c++){
				const prevCellFormat = getFormatName(view, start.row-1, c);
				if(prevCellFormat)
					for(let r = start.row; r <= end.row; r++)
						setFormat(view, r, c, prevCellFormat);
			}
	});
}

export let currencies = [];
export function initCurrencies(){
	if(currencies.length) return;
	currencies = [ webix.i18n.price ];
	currencies = currencies.concat(webix.copy(webix.i18n.spreadsheet.formats.currencies));

	currencies = currencies.map(format => {
		const id = getCurrencySymbol(format);
		return {
			format,
			id,
			value: id.trim()
		};
	});
}

const defaultFormats = {common:1};

function getCurrencySymbol(format){
	return webix.template(format)("");
}

export function setDefaultFormats(view){
	initCurrencies();
	const formatsLocale = webix.i18n.spreadsheet.formats;

	const formats = view._formats = {
		formats: {},
		formatsCount: 0,
		formatSources: {},
		formatCache: {},
		formatHelpers: {
			price : {
				getFormat : function(value, extra){
					extra.css = "webix_ssheet_format_price";
					return webix.i18n.priceFormat(value);
				},
				values:webix.extend({
					zeros: webix.i18n.priceSettings.decimalSize, 
					symbol: webix.i18n.price.replace("{obj}",""),
					separator: 1, negative:1, type: "price"
				}, getDelimiters("price"))
			},
			"int" : {
				getFormat : function(value, extra){
					extra.css = "webix_ssheet_format_int";
					return webix.i18n.numberFormat(value);
				},
				values:webix.extend({
					zeros: webix.i18n.decimalSize,
					separator: 1, negative:1, type: "int",
				}, getDelimiters("int"))
			},
			percent : {
				getFormat : function(value, extra){
					extra.css = "webix_ssheet_format_percent";
					return Math.round(value*100)+"%";
				},
				values:webix.extend({
					zeros: 0, separator: 0, negative:1, type: "percent",
				}, getDelimiters("percent"))
			},
			date : {
				getFormat : function(value, extra){
					extra.css = "webix_ssheet_format_date";
					return format2code(formatsLocale.dateFormat, getDelimiters("date"))(value);
				},
				values: { type:"date", date:formatsLocale.dateFormat }
			},
			string : {
				getFormat : function(value, extra){
					extra.css = "webix_ssheet_format_text";
					return value;
				},
				values: { type:"string" }
			}
		}
	};

	for(let i in formats.formatHelpers){
		defaultFormats[i] = 1;
		const source = formats.formatSources[i] = serializeFormat(formToValues(i, formats.formatHelpers[i].values));
		formats.formatCache[source] = i;
	}
}

export function getDelimiters(type){
	if(type == "price")
		return { groupSign:webix.i18n.priceSettings.groupDelimiter, decimalSign:webix.i18n.priceSettings.decimalDelimiter };
	else 
		return { groupSign:webix.i18n.groupDelimiter, decimalSign:webix.i18n.decimalDelimiter };
}

function serialize(view, data){
	const formats = [];
	for(let i in view._formats.formatSources)
		if(!defaultFormats[i]) //exclude default formats
			formats.push([i, view._formats.formatSources[i]]);
	data.formats = formats;
}

function load(view, data){
	const formats = data.formats;
	if(formats)
		for(let i = 0; i < formats.length; i++)
			createFormatName(view, formats[i][1],formats[i][0]);
}

export function getFormat(view, name){
	const formatHelpers = view._formats.formatHelpers;
	return formatHelpers[name] ? formatHelpers[name].getFormat : formatHelpers[name];
}

export function getFormatSource(view, name, toexcel){
	if(toexcel){
		const parsed = parseFormat({values: view._formats.formatHelpers[name].values, format: view._formats.formatSources[name]});
		return serializeFormat(parsed, true);
	}
	else
		return view._formats.formatSources[name];
}

function _createFormatName(view, name){
	name = typeof(name) == "object" || webix.isUndefined(name) ? "fmt"+(++view._formats.formatsCount) : name;

	while (view._formats.formats[name])
		name = "fmt"+(++view._formats.formatsCount);

	return name;
}

function createFormatName(view, str, values){
	if (view._formats.formatCache[str]) return view._formats.formatCache[str];

	const name = _createFormatName(view, values);
	view._formats.formats[name] = str;

	if(typeof(values) == "string")
		values = formatToForm(str);

	webix.extend(
		values,
		getDelimiters("custom")
	);

	const formats = view._formats;
	formats.formatHelpers[name] = {
		getFormat:format2code(str, {decimalSign: values.decimalSign, groupSign: values.groupSign}),
		values: values
	};

	formats.formatSources[name] = str;
	formats.formatCache[str] = name;

	return name;
}

export function createFormat(view, format, type) {
	if(!type)
		type = {format, type: "custom"};
	const name = createFormatName(view, format, type);

	view._sheets.map(sheet => {
		if(!sheet.content.formats)
			sheet.content.formats = [];
		if(!arr.find(sheet.content.formats, format => format[0] == name))
			sheet.content.formats.push([name, format]);	
	});

	return name;
}

export function setFormat(view, row, column, name, page){
	const oldStyle = view.getStyle(row, column, page);
	const newStyle = addStyle(view, { format: name }, oldStyle, page);
	view.setStyle(row, column, newStyle, page);
}

function applyAreaFormat(view, index, name, isRow) {
	let last = isRow ? view.config.columnCount : view.config.rowCount;
	for (let i = 1; i <= last; i++) {
		const row = isRow ? index : i;
		const column = isRow ? i : index;
		setFormat(view, row, column, name);
	}
}

export function addFormat(view, row, column, format, type, page){
	const name = createFormat(view, format, type);
	setFormat(view, row, column, name, page);
	return name;
}

export function removeFormat(view, row, column, page){
	setFormat(view, row, column, "", page);
}

function splitFormat(str){
	var conditional = str.match(/.*\[[><=].*/g);
	var parts = str.split(";");
	if (!conditional){
		if (parts.length > 1){
			parts[0] = (parts.length > 2 ? "[>0]" : "[>=0]")+parts[0];
			parts[1] = "[<0]"+parts[1];
			if (parts[2])
				parts[2] = "[=0]"+parts[2];
		}
	}
	return parts;
}

export function format2code(str, delimiters){
	const errorMessage = webix.i18n.spreadsheet.table["format-error"];
	let parts = splitFormat(str);
	let code = ["var spaces = \"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\";"];
	for (var i=0; i<parts.length; i++){
		var separated = separateFmt(parts[i]);
		code.push(genCode(separated.condition, separated.color.toLowerCase(), separated.symbol, separated.fmt, i, parts.length > 0, delimiters));
	}

	let method;
	try {
		method = new Function("val","extra", `try{ ${code.join("\n")} return val; } catch(err) { return "${errorMessage}"; }`);
	}
	catch(err){
		method = function(){return errorMessage;};
	}
	return method;
}

function genCode(check, color, symbol, line, ind, isAbs, delimiters){
	var str = "";
	if (check){
		if (!ind) str+="if"; else str+="else if";
		if (check[0] === "=") check = "="+check;
		str+="(val"+check+"){";
		if (isAbs) str+="val = Math.abs(val);";
	}
	if (color)
		str+="extra.css = \"webix_ssheet_format_"+color+"\";";

	str += genFormatCode(line, delimiters, symbol);

	return str+(check?"}":"");
}

const dateTypes = {
	"yy": "%y",
	"yyyy": "%Y",
	"m": "%n",
	"mm": "%m",
	"mmm": "%M",
	"mmmm": "%F",
	"mmmmm":"%F", //not supported by webix
	"d": "%j",
	"dd": "%d",
	"ddd": "%D",
	"dddd": "%l"
};

const timeTypes = {
	"h": "%G",
	"hh": "%H",
	"m": "%i", //not supported by webix
	"mm": "%i",
	"s": "%s", //not supported by webix
	"ss": "%s",
	"AM/PM": "%A",
	"0": "%S", //not supported by webix
	"00": "%S", //not supported by webix
	"000": "%S"
};

const dateOrder = Object.keys(dateTypes).sort((a, b) => b.length - a.length);
const timeOrder = Object.keys(timeTypes).sort((a, b) => b.length - a.length);

function excelDateToWebix(text, lastDateType){
	const typesOrder = [
		{name:"date", order:dateOrder, types:dateTypes}, 
		{name:"time", order:timeOrder, types:timeTypes}
	];

	// "m"/"mm" format can be either date (%n/%m) or time (%i), so check last date type
	const basedOnLast = /^m{1,2}(?!m)/.test(text);
	if(basedOnLast && lastDateType != "date")
		typesOrder.reverse();

	for(let i = 0; i < typesOrder.length; i++){
		const type = typesOrder[i];
		for(let j = 0; j < type.order.length; j++)
			if(text.indexOf(type.order[j]) == 0)
				return {
					format: type.types[type.order[j]],
					length: type.order[j].length,
					type: type.name
				};
	}
}

function genFormatCode(line, delimiters, symbol){
	if (!line)
		return "return val;";

	let str = "return \"\"";

	let isQuote;
	let fmt = "";
	let multiply = 1;
	let comma, numberPlaceholder, textPlaceholder;
	let date = [];
	let lastDateType = "date";

	let symbolPos;
	if(symbol){
		const currency = arr.find(currencies, val => val.id == symbol);
		symbolPos = "left";

		if(currency)
			symbolPos = arr.findIndex(currency.format.split("{obj}"), val => val) ? "right" : "left";
	}

	for (var i=0; i<line.length; i++){
		var betweenPlaceholders = placeholder(line[i-1])&&placeholder(line[i+1]);
		if (line[i] == "\""){
			if(webix.isUndefined(isQuote))
				isQuote = i;
			else {
				str += `+"${line.substr(isQuote+1, i-isQuote-1)}"`;
				isQuote = undefined;
			}
			continue;
		}
		if (!webix.isUndefined(isQuote))
			continue;
		if(line[i] == "%")
			multiply = multiply*100;

		// Excel lacks native MS time format
		// as a workaround, custom format "hh:mm:ss.000" is commonly used
		// so add support for the same format in the spreadsheet too
		const milliseconds = date.length && line[i] === "0" && line[i-1] === delimiters.decimalSign;

		if(/[a-zA-Z]/.test(line[i]) || milliseconds){
			const datePart = excelDateToWebix(line.substr(i), lastDateType);
			if(datePart){
				if(numberPlaceholder || textPlaceholder)
					return "throw \"unexpected number placeholder\";";
				date.push(datePart.format);
				str += "/*date*/"; //update this value after date format is ready
				lastDateType = datePart.type;
				i += datePart.length-1;
				continue;
			}
			else
				str += `+"${line[i]}"`;
		}
		else if (line[i] === delimiters.decimalSign && betweenPlaceholders){
			fmt+= delimiters.decimalSign;
		}
		else if(line[i]=="@"){
			if(numberPlaceholder || date.length)
				return "throw \"unexpected number placeholder\";";
			if(!textPlaceholder){
				str+="+fmt";
				textPlaceholder = true;
			}
			fmt+=line[i];		
		}
		else if (placeholder(line[i])){
			if(textPlaceholder || date.length)
				return "throw \"unexpected text placeholder\";";
			if (!numberPlaceholder) {
				if(symbolPos == "left")
					str += `+"${symbol}"`;
				str+="+fmt";
				if(symbolPos == "right")
					str += `+"${symbol}"`;
				numberPlaceholder=true;
			}
			fmt+=line[i];
		}
		else if (line[i] === delimiters.groupSign && betweenPlaceholders)
			comma = true;
		else
			str += `+"${line[i]}"`;
	}

	if(date.length){
		// 12-hour or 24-hour clock depends on AM/PM in format
		if(date.indexOf("%A") != -1)
			date = date.map(datePart => {
				switch(datePart){
					case "%G": return "%g";
					case "%H": return "%h";
					default: return datePart;
				}
			});

		for(let i = 0; i < date.length; i++)
			str = str.replace("/*date*/", `+dateParts[${i}]`);
	}

	return `
		${date.length ? `val = (${getJsDateFromExcel})(val); var dateParts = webix.Date.dateToStr("${date.join(";")}")(val).split(";");` : ""}
		${fmt ? `${numberFormat(fmt, comma, delimiters, multiply)};` : ""}
		${str};`;
}

function numberFormat(fmt, comma, delimiters, multiply){
	var str = `if(/^@+$/.test("${fmt}") || isNaN(val)){ var fmt = val; }else {`;
	var decimal = delimiters.decimalSign;
	var [left, right] = getParts(fmt, decimal);
	right = (right || "").split("").reverse().join("");

	//calculate indexes in mask
	var lzeros = left.indexOf("0"); if (lzeros>=0) lzeros = left.length - lzeros;
	var lfills = left.indexOf("?"); if (lfills>=0) lfills = left.length - lfills;
	var rzeros = right.indexOf("0"); if (rzeros>=0) rzeros = right.length - rzeros;
	var rfills = right.indexOf("?"); if (rfills>=0) rfills = right.length - rfills;
	var rmax = right.length;

	str += `
	val = val*${multiply};
	var parts = val.toFixed(${rmax}).split(".");
	var left = parts[0];
	var lsize = left.length; 
	var right = parts[1] || "";
	if (left.length < ${lzeros}) left = "0000000000".substr(0, ${lzeros} - left.length)+left;
	if (left.length < ${lfills}) left = spaces.substr(0, 6*(${lfills} - left.length))+left;
	if (${comma}) {
		var buf = [];
		var start = 3;
		while (lsize > start) { buf.push(left.substr(left.length-start,3)); start+=3; }
		var last = left.substr(0,left.length-start+3);
		if (last !== "-")
			buf.push(last);
		else
			buf.push("-"+buf.pop());

		left = buf.reverse().join("${delimiters.groupSign}");
	}
	if (right){
		var zpoint = right.length-1;
		while (zpoint >= ${rzeros}){
			if (right[zpoint] !== "0"){
				break;
			}
			zpoint--;
		}

		if (zpoint <= right.length)
			right = right.substr(0, zpoint+1);

		if (right.length < ${rfills}){
			right += spaces.substr(0, 6*(${rfills} - right.length));
		}
	}
	var fmt = left+(right?"${decimal}":"")+right;
	`;

	return str+"}\n";
}

function updateDecimals(fmt, inc, val){
	let parsed = parseFormat(fmt);
	for(let i = 0; i < parsed.length; i++){
		if(parsed[i].decimals){
			if(inc>0)
				parsed[i].right.placeholders += Array(inc+1).join("0");
			else
				parsed[i].right.placeholders = parsed[i].right.placeholders.slice(0, inc);
		}
		else{
			const withoutText = !parsed[i].left.text && !parsed[i].right.text;
			const withoutPlaceholders = !parsed[i].left.placeholders && !parsed[i].right.placeholders;
			//check if cell value have decimals (not cell format)
			if(inc < 0 && withoutText && withoutPlaceholders && webix.rules.isNumber(val) && val.indexOf(".") > -1){
				parsed[i].left.placeholders = "0";
				parsed[i].right.placeholders = Array(val.split(".")[1].length).join(Array(inc+1).join("0"));
			}
			//ignore text
			else if(inc > 0 && (parsed[i].left.placeholders || withoutText)){
				parsed[i].left.placeholders = parsed[i].left.placeholders || "0";
				parsed[i].right.placeholders = Array(inc+1).join("0");
				parsed[i].decimals = true;
			}
		}
		parsed[i].decimals = parsed[i].right.placeholders.length > 0;
	}

	return serializeFormat(parsed);
}

export function changeAreaDecimals(view, inc, row, column, page){
	const isActiveSheet = !page || page == view.getActiveSheet();
	const sheet = isActiveSheet ? view._mPage : view._mData.getPage(page);
	if(!sheet)
		return;

	const cells = getCells(view, row, column);
	if(cells.length == 0)
		return;

	const obj = sheet.getCell(cells[0].row-1, cells[0].column-1);
	const oldFormat = obj && obj.format;
	const value = (obj && obj.value) ? obj.value.toString() : "";
	
	if(webix.rules.isNumber(value) || oldFormat){
		group.set(function(){
			for(let i = 0; i < cells.length; i++)
				changeCellDecimals(view, inc, cells[i], page, sheet);
		});

		if(isActiveSheet){
			view.refresh();

			let format = getFormatName(view, cells[0].row, cells[0].column) || "common";
			format = isCustom(format) ? "custom" : format;
			view.callEvent("onCommand", [{id:"toolbar-update", name:"format", value:format}]);
		}
	}
}

function changeCellDecimals(view, inc, cell, page, sheet){
	let format;
	const obj = sheet.getCell(cell.row-1, cell.column-1);
	const oldFormat = obj && obj.format;
	const value = (obj && obj.value) ? obj.value.toString() : "";

	if(oldFormat){
		format = webix.copy({values:view._formats.formatHelpers[oldFormat].values, format:getFormatSource(view, oldFormat)});
		format.format = updateDecimals(format, inc, value);

		if(format.values && Object.prototype.hasOwnProperty.call(format.values, "zeros"))
			format.values.zeros = Math.max(format.values.zeros+inc, 0);
	}
	//add format for cell without format
	else{
		const zeros = webix.rules.isNumber(value) && value.split(".")[1] ? Math.max(value.split(".")[1].length+inc, 0) : Math.max(inc, 0);

		format = {values:{negative:1, zeros:zeros, separator:0, type:"int"}};
		format.format = serializeFormat(formToValues(format.values.type, format.values));
	}
	addFormat(view, cell.row, cell.column, format.format, format.values, page);
}

export function isCustom(name){
	return !defaultFormats[name];
}

export function formToValues(type, formValues){
	if(type == "string")
		return [{left:{text:"@"}}];
	if(formValues.date)
		return [{left:{text:formValues.date}}];

	let values = [{condition:">=0", left:{text:""},right:{text:""}}, {condition:"<0", left:{text:""}, right:{text:""}}];
	webix.extend(values, getDelimiters(type));
	values[0].right.placeholders = values[1].right.placeholders = formValues.zeros ? Array(formValues.zeros + 1).join("0") : "";
	values[0].separator = values[1].separator = formValues.separator && type != "percent";
	values[0].left.placeholders = values[1].left.placeholders = values[0].separator ? "#"+values.groupSign +"0" : "0";
	values[0].decimals = values[1].decimals = formValues.zeros ? true : false;
	values[1].color = formValues.negative != 1 ? "red" : "";
	values[1].left.text += formValues.negative < 3 ? "-" : "";
	if(formValues.negative == 4)
		values[1].left.text += "(";

	if(type === "percent")
		values[0].right.text = values[1].right.text += "%";
	else if(type === "price"){
		const symbolId = formValues.symbol;
		const currency = arr.find(currencies, val => val.id == symbolId);
		const pos = arr.findIndex(currency.format.split("{obj}"), val => val) ? "right" : "left";

		values[0][pos].symbol = values[1][pos].symbol = symbolId;
	}

	if(formValues.negative == 4)
		values[1].right.text += ")";

	return values;
}

function formatToForm(format){
	const formatsLocale = webix.i18n.spreadsheet.formats;
	const dates = [
		formatsLocale.dateFormat,
		formatsLocale.timeFormat,
		formatsLocale.fullDateFormat,
		formatsLocale.longDateFormat
	];
	const form = {format, type:"custom"};

	if(arr.find(dates, date => date == format)){
		webix.extend(form, {
			type:"date", date:format
		}, true);
	}
	else{
		let [first, second] = format.split(";");
		if(first && second){
			if(first.indexOf("[>=0]") == 0 && second.indexOf("[<0]") == 0){
				first = first.replace("[>=0]", "");
				second = second.replace("[<0]", "");

				let red;
				if(second.indexOf("[red]") == 0){
					second = second.replace("[red]", "");
					red = true;
				}

				if(second[0] == "-"){
					second = second.substring(1);
					form.negative = red ? 2 : 1;
				}
				else if(red){
					if(second[0] == "(" && second[second.length-1] == ")"){
						form.negative = 4;
						second = second.substring(1, second.length-1);
					}
					else
						form.negative = 3;
				}

				if(form.negative && first == second){
					let type = "int";
					let priceBrackets = first.indexOf("[$") != -1;

					if(first[first.length-1] == "%"){
						first = first.substring(0, first.length-1);
						type = "percent";
					}
					else{
						for(let i = 0; i < currencies.length; i++){
							const currency = currencies[i].id;
							let isPrice;

							if(priceBrackets){
								if(first.indexOf(`[$${currency}]`) != -1){
									first = first.replace(`[$${currency}]`, "");
									isPrice = true;
								}
							}
							else if(first.indexOf(currency) != -1){
								first = first.replace(currency, "");
								isPrice = true;
							}

							if(isPrice){
								type = "price";
								form.symbol = currency;
								break;
							}
						}
					}

					const delimiters = getDelimiters(type);

					if(first.indexOf("#"+delimiters.groupSign) == 0){
						first = first.replace("#"+delimiters.groupSign, "");
						form.separator = 1;
					}

					const [integer, decimal] = first.split(delimiters.decimalSign);
					if((!integer || integer == "0") && (!decimal || /^[0]+$/.test(decimal))){
						form.type = type;
						form.delimiters = delimiters;
						form.zeros = decimal ? decimal.length : 0;
					}
				}
			}
		}
	}
	return form;
}

export function serializeFormat(values, toExcel){
	let fmt = "";
	for(let i = 0; i < values.length; i++){
		if(values[i].condition)
			fmt += "["+values[i].condition+"]";
		if(values[i].color)
			fmt += "["+values[i].color+"]";

		if(values[i].left){
			if(values[i].left.text){
				let leftText = values[i].left.text;
				fmt += leftText;
			}
			if(values[i].left.symbol)
				fmt += "[$"+values[i].left.symbol+"]";
			if(values[i].left.placeholders){
				let leftPlaceholders = values[i].left.placeholders;
				fmt += toExcel ? leftPlaceholders.replace(values.groupSign, ",") : leftPlaceholders;
			}
		}

		if(values[i].decimals)
			fmt += toExcel ? "." : values.decimalSign;

		if(values[i].right){
			if(values[i].right.placeholders)
				fmt += values[i].right.placeholders;
			if(values[i].right.symbol)
				fmt += "[$"+values[i].right.symbol+"]";
			if(values[i].right.text){
				let rightText = values[i].right.text;

				fmt += rightText;
			}
		}
		if(i != values.length - 1)
			fmt += ";";
	}
	return fmt;
}

function parseFormat(fmt){
	const fmtParts = fmt.format.split(";");
	let values = [];

	for(let i = 0; i < fmtParts.length; i++){
		let separated = separateFmt(fmtParts[i]);
		values[i] = {color:separated.color, condition:separated.condition ,left:{}, right:{}};

		const format = separated.fmt;

		values.groupSign = fmt.values.groupSign;
		values.decimalSign = fmt.values.decimalSign;

		if(format.indexOf(values.groupSign) > -1)
			values[i].separator = true;

		const sepFmtParts = getParts(format, values.decimalSign);

		let left = sepFmtParts[0];
		let right = sepFmtParts[1] || "";

		if(sepFmtParts[1])
			values[i].decimals = true;

		left = getFmtPartValues(left, "left", values.groupSign);
		right = getFmtPartValues(right, "right", values.groupSign);

		values[i].left = {
			text: left.leftText,
			placeholders: left.placeholders
		};

		values[i].right = {
			text: left.rightText + right.rightText,
			placeholders: right.placeholders
		};

		const symbol = separated.symbol;
		if(symbol){
			const currency = arr.find(currencies, val => val.id == symbol);
			let pos = "left";

			if(currency)
				pos = arr.findIndex(currency.format.split("{obj}"), val => val) ? "right" : "left";

			values[i][pos].symbol = symbol;
		}
	}
	return values;
}

function getFmtPartValues(fmtPart, type, groupSign){
	let firstPlaceholder;
	if(type == "left"){
		firstPlaceholder = fmtPart.match(/[#?0]/);
		firstPlaceholder = firstPlaceholder ? firstPlaceholder.index : Infinity;
	}

	let leftText = "";
	let rightText = "";
	let placeholders = "";
	for(let k = 0; k < fmtPart.length; k++){
		if(!placeholder(fmtPart[k])){
			if(fmtPart[k] == groupSign && placeholder(fmtPart[k+1]) && placeholder(fmtPart[k-1])){
				placeholders += fmtPart[k];
				continue;
			}
			if(type == "left")
				if(k < firstPlaceholder){
					leftText += fmtPart[k];
					continue;
				}
			rightText += fmtPart[k];
		}
		else
			placeholders += fmtPart[k];
	}
	return {leftText: leftText, rightText: rightText, placeholders: placeholders};
}

function separateFmt(line){
	let color = "";
	let check = "";
	let symbol = "";

	let start = line.indexOf("[");
	if (start != -1){
		if (line[1].match(/[><=]/)){
			let end = line.indexOf("]");
			check = line.substr(start+1, end-start-1);
			line = line.substr(end+1);
		}
	}

	start = line.indexOf("[$");
	if(start != -1){
		let end = start + line.substr(start).indexOf("]");
		symbol = line.substr(start+2, end-start-2);
		line = line.substr(0, start)+line.substr(end+1);
	}

	start = line.indexOf("[");
	if (start != -1){
		let end = line.indexOf("]");
		color = line.substr(start+1, end-start-1);
		line = line.substr(end+1);
	}
	return {condition:check, color, symbol, fmt:line};
}

function getCells(view, row, column){
	if(row && column){
		if (typeof row === "object" && typeof column === "object"){
			let cells = [];
			for (let r = row.row; r<=column.row; r++)
				for (let c = row.column; c<=column.column; c++)
					cells.push({row: r, column: c});
			return cells;
		}
		else
			return [{row: row, column: column}];
	}
	else
		return view.getSelectedId(true);
}

function placeholder(val){
	return val === "0" || val === "#" || val === "?";
}

function getParts(str, decimal){
	// it is nessesary to use "/" before decimal to escape regex special characters
	const match = str.match("[#?0][/"+decimal+"][#?0]");
	if(match)
		return [str.substring(0, match.index+1), str.substring(match.index+2)];
	else
		return [str];
}

//simple check: take into account only first condition
export function checkFormat(view, format, type, checkTime){
	format = format && format.fmt ? format.fmt : getFormatSource(view, format);
	if(!format) return;
	const parts = splitFormat(format);
	const separated = separateFmt(parts[0]).fmt;

	let quot;
	if(separated)
		for(let i = 0; i < separated.length; i++){
			if(separated[i] == "\"")
				quot = !quot;
			if(quot) continue;

			if(type == "date" && /[a-zA-Z]/.test(separated)){
				const datePart = excelDateToWebix(separated.substr(i), "date");
				if(datePart){
					if(checkTime){
						if(datePart.type == "time")
							return true;
						else if(checkTime == "onlyTime")
							return false;
					}
					else
						return true;
				}
			}

			if(type == "string" && separated[i] == "@")
				return true;
		}
}

export function getFormatName(view, row, col, page){
	const isActiveSheet = !page || page == view.getActiveSheet();
	const sheet = isActiveSheet ? view._mPage : view._mData.getPage(page);
	if(!sheet)
		return;
	const item = sheet.getCell(row-1, col-1);
	return (item && item.format) || null;
}

export function isDateInvalid(value){
	return value < -99974430.925 || value > 100025569.125;
}

export function getDateEditFormat(view, row, col){
	const formatName = getFormatName(view, row, col);
	const locale = webix.i18n.spreadsheet.formats;
	const isTime = checkFormat(view, formatName, "date", true);

	return webix.Date.dateToStr( locale[isTime ? "parseDateTime" : "parseDate"] );
}

export function getFormatFromData(view, data, array){
	const styleName = array[3];
	let fmt;
	if(styleName){
		let style = arr.find(data.styles, arr => arr[0] == styleName);
		if(style){
			style = style[1];
			const fmtName = styleFromText(style).format;
			if(fmtName){
				if(data.formats)
					fmt = arr.find(data.formats, arr => arr[0] == fmtName);

				if(fmt)
					fmt = fmt[1];
				else
					fmt = getFormatSource(view, fmtName); //default formats (int, percent, etc.)
			}
		}
	}
	return fmt;
}

export function clearFormatCache(view){
	const formats = view._formats;
	for(let name in formats.formats){
		delete formats.formatCache[formats.formats[name]];
		delete formats.formatHelpers[name];
		delete formats.formatSources[name];
	}
	formats.formats = {};
	formats.formatsCount = 0;
}

export function updateFormats(view, obj){
	if(!obj.styles) return;
	const loadStyles = webix.copy(obj.styles);

	const formats = view._formats;
	if(formats.formatsCount > 0){
		obj.formats.forEach(fmt => {
			const oldName = fmt[0];
			const cachedName = formats.formatCache[fmt[1]];
			if(cachedName){
				if(fmt[0] == cachedName)
					return;
				fmt[0] = cachedName;
			}
			else
				fmt[0] = _createFormatName(view);

			for (let i = 0; i < loadStyles.length; i++) {
				const style = styleFromText(loadStyles[i][1]);
				if(style.format == oldName){
					style.format = fmt[0];
					obj.styles[i][1] = styleToText({props:style});
				}
			}
		});
	}
}

export function removeUnusedFormats(formats, usedFormats){
	if(usedFormats && Object.keys(usedFormats).length != formats.length){
		const newFormats = [];
		for(let i = 0; i < formats.length; i++){
			const name = formats[i][0];
			if (usedFormats[name])
				newFormats.push(formats[i]);
		}
		return newFormats;
	}
}